import { PageViewEventLogger } from '@repo/tracking-service';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import { employmentContractsQuery } from '@/__generated__/employmentContractsQuery.graphql';
import Spinner from '@/components/common/Spinner';
import { SurveyLayout } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';
import { ContractsContainer } from '@/components/survey/employment/contracts/ContractsContainer';
import { contractsQuery } from '@/graphql/query/survey/employment';
import { refundHistoryIdAtom } from '@/lib/stores/survey/common';

function EmploymentContractsPage() {
  const [queryRef, loadQuery] = useQueryLoader<employmentContractsQuery>(contractsQuery);
  const refundHistoryId = useAtomValue(refundHistoryIdAtom);
  const eventAttributes = useSurveyUserEventAttributes();

  useEffect(() => {
    if (refundHistoryId) {
      loadQuery({ refundHistoryId }, { fetchPolicy: 'network-only' });
    }
  }, [refundHistoryId, loadQuery]);

  if (!queryRef) return <Spinner />;
  return (
    <PageViewEventLogger pageName={'survey_employment-contract'} eventProperty={eventAttributes}>
      <ContractsContainer queryRef={queryRef} />
    </PageViewEventLogger>
  );
}

EmploymentContractsPage.getLayout = SurveyLayout;

export default EmploymentContractsPage;
